import ReactGA from "react-ga4";

// Initialize Google Analytics
export const initGA = () => {
  ReactGA.initialize("G-DSQDP0KQ7H"); //  GA4 Measurement ID
};
const IsProd = process.env.REACT_APP_IS_PROD == "true";
// Log a page view with a unique title and path
export const logPageView = (pageTitle, pagePath) => {
  console.log(`Logging page view: ${pageTitle} (${pagePath})`);
  if (IsProd) {
  ReactGA.send({
    hitType: "pageview",
    page_title: pageTitle,
    page_path: pagePath,
  });
}
};

// Log Key Events
export const logEvent = (eventName, eventParams = {}) => {
  const eventData = {
    action: eventName,
    category: "Key Events",
    ...eventParams,
  };

  ReactGA.event(eventData);
};

// Track page navigation event
export const trackPageNavigation = (page) => {
  ReactGA.event({
    category: "Navigation",
    action: "Go to Page",
    label: page,
  });
};

// Define logInteraction function for tracking interactions
export const logInteraction = (interaction) => {
  ReactGA.event({
    category: "Interaction",
    action: "User interaction",
    label: interaction,
  });
};
